// Wolf — ported verbatim from GolfGamesScorecard's calcWolf (utils/scoring.ts).
// Each hole the Wolf either partners up or goes it alone (Lone Wolf). Lone Wolf
// win = 3 to the wolf; loss = 2 to each opponent. Partnered win = 1 each to the
// wolf pair; loss = 2 to each of the other players. wolfData[].hole is a 0-based
// hole index.
export function calcWolf(players, wolfData) {
  const points = {}
  players.forEach((p) => { points[p.id] = 0 })
  ;(wolfData || []).forEach((hole) => {
    const scores = players.map((p) => ({ id: p.id, score: p.scores[hole.hole] ?? 999 }))
    const minScore = Math.min(...scores.map((s) => s.score))
    const holeWinnerId = scores.find((s) => s.score === minScore)?.id
    if (!holeWinnerId) return
    if (hole.loneWolf) {
      if (holeWinnerId === hole.wolfId) points[hole.wolfId] += 3
      else players.filter((p) => p.id !== hole.wolfId).forEach((p) => { points[p.id] += 2 })
    } else {
      const wolfTeam = new Set([hole.wolfId, hole.partnerId])
      if (wolfTeam.has(holeWinnerId)) {
        points[hole.wolfId] += 1
        if (hole.partnerId) points[hole.partnerId] += 1
      } else {
        players.filter((p) => !wolfTeam.has(p.id)).forEach((p) => { points[p.id] += 2 })
      }
    }
  })
  return players.map((p) => ({ ...p, points: points[p.id] })).sort((a, b) => b.points - a.points)
}
